export const siteConfig = {
  name: "The Wiki",
  description: "Wiki For Us",
  homePageText: "This is the wiki for us.",
} 
